import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import ArgonBox from "components/ArgonBox";
import AvatarWithLoader from "../../Components/Avatar/AvatarWithLoader";

const dummyBio =
  "Adventure seeker | Book lover | Always up for a game night or spontaneous hike.";

export default function RefreesModal({ open, onClose, selectedReferral }) {
  const tableData = {
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Bio", accessor: "bio", align: "left" },
    ],
    rows:
      selectedReferral?.referredUsers?.slice(0, 4).map((user) => ({
        name: (
          <Box display="flex" alignItems="center">
            <AvatarWithLoader src={user.profileImage} alt={user.name} />
            <Typography variant="h6" fontWeight="bold">
              {user.name}
            </Typography>
          </Box>
        ),
        bio: (
          <Typography variant="h6" color="text.secondary">
            {user.bio || dummyBio}
          </Typography>
        ),
      })) || [],
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="1000px"
      disableBackdropClick
      PaperProps={{
        style: {
          borderRadius: "16px",
          padding: "40px 32px",
          textAlign: "center",
          backgroundColor: "#ffffff",
        },
      }}
    >
      <DialogTitle
        sx={{ textAlign: "center", pt: 4, pb: 2, fontSize: "1.5rem" }}
      >
        Referred User
      </DialogTitle>

      {selectedReferral && (
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          gap={1}
        >
          <AvatarWithLoader
            src={selectedReferral.profileImage}
            alt={selectedReferral.name}
          />
          <ArgonBox display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h6" fontWeight="bold">
              {selectedReferral.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {selectedReferral.email}
            </Typography>
          </ArgonBox>
        </Box>
      )}

      <ArgonBox
        border="0.5px solid #E0E0E0"
        borderRadius="16px"
        p={2}
        shadow="sm"
        mt={2}
      >
        <DataTable
          table={tableData}
          entriesPerPage={false}
          canSearch={false}
          showTotalEntries={false}
          pagination={false}
          isSorted={false}
          noEndBorder
        />
      </ArgonBox>

      <DialogActions sx={{ justifyContent: "center", p: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            color: "text.secondary",
            borderColor: "text.secondary",
            "&:hover": {
              borderColor: "text.primary",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
